<template>
  <el-dialog
    title=""
    :visible.sync="isShow"
    width="55%"
    :show-close="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="closeDia"
  >
    <template slot="title">
      <span class="el-dialog__title">转接</span>
    </template>
    <div style="margin-bottom: 10px">选择需要转接的坐席人员</div>
    <div class="service_div">
      <div v-for="(item, index) in serviceList" :key="index">
        <div
          @click="selectService(item)"
          :class="{
            service_item: !item.selected,
            service_selected: item.selected,
          }"
        >
          <img class="left_header" :src="item.imageUrl" />
          <div class="right_item">
            <label class="service_name"
              >{{ item.name }}
              <span style="color: #de4f4f"
                >({{ item.sessionCount }})</span
              ></label
            >
            <label
              :class="{
                service_state: item.state === '在线',
                service_busy: item.state === '忙碌',
                service_leave: item.state == '离线',
              }"
              class="stateClass"
              >[{{ item.state }}]</label
            >
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <label class="footer_lb">所属站点：{{ station }}</label>
      <el-button @click="cancel">取 消</el-button>
      <el-button
        v-if="serviceList.length == 0 || selectedService == null"
        type="info"
        disabled
        >确 定</el-button
      >
      <el-button v-else type="primary" @click="handleSure">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "transter",
  props: ["showDialog", "serviceList", "type"], ////0-我的会话转接 2-同事的会话转接 1-离开触发的弹框

  data() {
    return {
      selectedService: null,
      isShow: this.showDialog,
      station: "",
      customList: this.serviceList,
      iType: this.type,
    };
  },

  watch: {
    serviceList(val1, val2) {
      console.log("transter serviceList val1 = ", val1);
      console.log("transter serviceList val2 = ", val2);

      this.customList = val1;
    },

    type(val1, val2) {
      console.log("transter type val1 = ", val1);
      console.log("transter type val2 = ", val2);
      this.iType = val1;
    },
    showDialog(val1, val2) {
      console.log("this.isShow  val1", val1);
      console.log("this.isShow val2 ", val2);
    },
  },

  mounted() {
    const site = this.util.getLocalSite();
    this.station = site.webId;
    console.log("transter mounted customList = ", this.customList);
  },

  methods: {
    closeDia(){
      this.$emit("closeTranster", false);
    },
    handleSure() {
      console.log("sure slectedservice000 = ", this.selectedService);
      if (this.selectedService === null) {
        this.$confirm("请确认是否已经选择转接客服！", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {})
          .catch(() => {});

        return;
      }

      var tipstr = "";
      var msgstr = "";
      if (this.iType === "0") {
        tipstr = "你确认要设置转接吗？";
        msgstr =
          "确认转接后，该访客将从自己的对话列表中删除，转移到指定客服的对话列表中。";
      } else if (this.iType === "1") {
        tipstr = "你确认离开后要设置转接吗？";
        msgstr =
          "确认转接后，该访客将从自己的对话列表中删除，转移到指定客服的对话列表中。";
      } else if (this.iType === "2") {
        tipstr = "你确认要将此会话转接给他人吗？";
        msgstr =
          "确认转接后，该访客将从此客服的对话列表中删除，转移到指定客服的对话列表中。";
      }
      this.$confirm(tipstr, msgstr, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log("sure slectedservice = ", this.selectedService);
          this.$emit("setCustomer", this.isShow, this.selectedService);
        })
        .catch(() => {});
    },

    cancel() {
      console.log("transter cancel");
      this.isShow = false;
      this.$emit("closeTranster", false);
    },

    selectService(obj) {
      console.log("transter selectService obj = ", obj);
      console.log("transter customList0000 = ", this.customList);
      for (let i = 0; i < this.customList.length; i++) {
        var service = this.customList[i];
        if (service.csid === obj.csid) {
          service.selected = true;
          this.selectedService = service;
        } else {
          service.selected = false;
        }
      }

      console.log("custom lst = ", this.customList);
    },
  },
};
</script>

<style>
.footer_lb {
  font-size: 15px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #444444;
  /* background-color: cyan; */
  position: absolute;
  left: 20px;
  margin-top: 10px;
}

.dialog-footer {
  width: 100%;
  /* background-color: yellow; */
}

.service_div {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  /* background-color: gold; */
}

.right_item,
.service_item,
.service_selected {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.service_item,
.service_selected {
  flex-direction: row;
}

/* .service_item:hover {
		border: 2px solid #5A9CF8;
	} */

.service_item,
.service_selected {
  /* width: 140px; */
  height: 80px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  padding: 0 0.5rem;
  margin-left: 8px;
  margin-right: 8px;
  margin-bottom: 16px;
}

.service_selected {
  border: 2px solid #5a9cf8;
}

.right_item {
  /* width: 50%; */
  height: 100%;
  /* background-color: cyan; */
  align-items: flex-start;
  margin-left: 10px;
}

.left_header {
  width: 2.75rem;
  height: 2.75rem;
  box-shadow: 0px 0px 4px 0px #85a9e4;
  border-radius: 0.375rem;
}

.service_name {
  font-size: 15px;
  font-family: PingFang-SC-Heavy, PingFang-SC;
  font-weight: 800;
  color: #444444;
  margin-bottom: 6px;
}

.stateClass {
  font-size: 13px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #5a9cf8;
}
.service_state {
  color: #07c160;
}

.service_busy {
  color: #f85a5a;
}

.service_leave {
  color: rgba(68, 68, 68, 0.5);
}
.el-dialog__title {
  display: flex;
  color: #333;
  font-weight: 600;
  line-height: 1;
}

.el-dialog__title::before {
  display: block;
  content: "";
  width: 3px;
  height: auto;
  background-color: #1577d2;
  margin-right: 6px;
}
</style>
<style scoped lang="scss">
::v-deep  .el-dialog {
  .el-dialog__body {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
